/**
 * AuditLogViewer Component
 * Main container for viewing audit logs with filters, table, and export
 */

import React from 'react';
import { useAuditLogs } from '../../hooks/useAuditLogs';
import { AuditLogFilters } from './AuditLogFilters';
import { AuditLogTable } from './AuditLogTable';
import { ExportButton } from './ExportButton';
import { ErrorAlert } from '../ErrorAlert';

export const AuditLogViewer: React.FC = () => {
  const {
    logs,
    users,
    filters,
    loading,
    loadingUsers,
    error,
    hasMore,
    setFilters,
    loadMore,
    refresh,
  } = useAuditLogs();

  return (
    <div className="space-y-4">
      {/* Header with export button */}
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-900">Audit Log</h2>
        <ExportButton logs={logs} disabled={loading} />
      </div>

      {/* Filters */}
      <AuditLogFilters
        filters={filters}
        users={users}
        loadingUsers={loadingUsers}
        onFilterChange={setFilters}
        onApply={refresh}
      />

      {/* Error display */}
      {error && <ErrorAlert message={error} />}

      {/* Table */}
      <AuditLogTable
        logs={logs}
        loading={loading}
        hasMore={hasMore}
        onLoadMore={loadMore}
      />
    </div>
  );
};
